import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const EventField = ({ source, record, basePath, ...props }) => {
	const translate = useTranslate();
	return (
		<Typography {...props}>
			{translate(`resources.events.code.${get(record, source)}`)}
		</Typography>
	);
};
export default EventField;
